// ======================
// > SHIMS
// ======================
import 'es5-shim'
import 'es6-shim'
import 'es7-shim'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import axios from 'axios/dist/axios.min.js'
import VueAnalytics from 'vue-analytics'
import 'vuetify/dist/vuetify.min.css'
import store from '@/store'
import Pusher from 'pusher-js'

// Airbrake for error tracking
import AirbrakeClient from 'airbrake-js'

var airbrake = new AirbrakeClient({
  projectId: 218810,
  projectKey: '5a53174c793696e1e4d838abbec6344e'
})

Vue.config.errorHandler = function (err, vm, info) {
  airbrake.notify({
    error: err,
    params: {info: info}
  })
}

Vue.use(Vuetify)

Vue.config.productionTip = false

const pusher = new Pusher(process.env.PUSHER_KEY, {
  cluster: process.env.PUSHER_CLUSTER,
  encrypted: true
})

Vue.use(VueAnalytics, {
  id: 'UA-1610393-14',
  set: [
    {field: 'app_version', value: process.env.STS_VERSION}
  ],
  router
})

// ======================
// > Config
// ======================
Vue.prototype.$http = axios
Vue.prototype.$pusher = pusher

// ======================
// > Initialize
// ======================
/* eslint-disable no-new */
new Vue({
  store,
  el: '#app',
  router,
  created () {
    store.commit('setCheckinKey', this.$route.params.checkin_key)
  },
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js